import { render, staticRenderFns } from "./Versus.vue?vue&type=template&id=5650d044&scoped=true&"
import script from "./Versus.vue?vue&type=script&lang=ts&"
export * from "./Versus.vue?vue&type=script&lang=ts&"
import style0 from "./Versus.vue?vue&type=style&index=0&id=5650d044&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650d044",
  null
  
)

export default component.exports